// Service pour gérer les outils de dessin avec Leaflet + Geoman
const DrawService = {
    map: null,
    collection: null,
    featureGroup:null, 
    options: {
        zoomPadding: { paddingTopLeft: [800, 0] } // Format Leaflet: paddingTopLeft et paddingBottomRight
    },
  
    /**
     * Initialise le service avec une instance de carte Leaflet.
     * Doit être appelé avant toute autre méthode.
     * @param {L.Map} mapInstance - instance de la carte Leaflet
     * @param {L.featureGroup} featureGroup - instance de featuregroup Leaflet
     * @param {Object} options - options du service (zoomPadding: [number, number])
     */
    init(mapInstance,featureGroup, options = {}) {
        this.map = mapInstance;
        this.featureGroup = featureGroup;
        // Fusionne les options avec les valeurs par défaut
        this.options = { ...this.options, ...options };
    },
    
    createExtraMarker({icon = "fa-circle", markerColor = "#252525", iconColor = "#ffffff", shape = "circle", prefix = "fa", svg = true}){
        if(icon == " " || icon == "") icon = "fa-circle";
        return L.ExtraMarkers.icon({
            icon: icon,
            markerColor: markerColor,
            iconColor: iconColor,
            shape: shape,
            prefix: prefix,
            svg:svg
        });
    },

    updateStyleLayer(formvalue,idlayer,type){
        this.featureGroup.eachLayer((layer) => {
            if (layer.data && layer.data.id === idlayer) {
                if(type === 'marker'){                
                    if(formvalue.polyColor){
                        const objdata = {
                            icon:layer.options.icon.options.icon,
                            markerColor:formvalue.polyColor,
                            iconColor:layer.options.icon.options.iconColor,
                            shape:layer.options.icon.options.shape,
                            prefix:layer.options.icon.options.prefix,
                            svg:true
                        }
                        const newIcon = this.createExtraMarker(objdata);
                        layer.setIcon(newIcon);
                        layer.data = {
                            ...layer.data,
                            options: {
                                ...layer.data.options,
                                icon: newIcon
                            }
                        };
                    }
                }else if (type === 'polyline') {
                    // Modifier la couleur, l'épaisseur (weight) et l'opacité
                    if (formvalue.polycontourColor) {
                        layer.setStyle({ color: formvalue.polycontourColor });                        
                        layer.data = {
                            ...layer.data,
                            options: {
                                ...layer.data.options,
                                color: formvalue.polycontourColor
                            }
                        };
                    }
                    if (formvalue.polycontourEpaisseur && formvalue.polycontourEpaisseur != 0) {
                        layer.setStyle({ weight: formvalue.polycontourEpaisseur });                     
                        layer.data = {
                            ...layer.data,
                            options: {
                                ...layer.data.options,
                                weight: formvalue.polycontourEpaisseur
                            }
                        };
                    }
                    if (formvalue.polycontourOpacity) {
                        layer.setStyle({ opacity: formvalue.polycontourOpacity });                   
                        layer.data = {
                            ...layer.data,
                            options: {
                                ...layer.data.options,
                                opacity: formvalue.polycontourOpacity
                            }
                        };
                    }
                } else if (type === 'polygon' || type === 'circle' || type === 'rectangle') {
                    // Modifier couleur, épaisseur, opacité pour polygones et rectangles
                    if (formvalue.polycontourColor) {
                        layer.setStyle({ color: formvalue.polycontourColor });                 
                        layer.data = {
                            ...layer.data,
                            options: {
                                ...layer.data.options,
                                color: formvalue.polycontourColor
                            }
                        };
                    }
                    if (formvalue.polycontourEpaisseur && formvalue.polycontourEpaisseur != 0) {
                        layer.setStyle({ weight: formvalue.polycontourEpaisseur });               
                        layer.data = {
                            ...layer.data,
                            options: {
                                ...layer.data.options,
                                weight: formvalue.polycontourEpaisseur
                            }
                        };
                    }
                    if (formvalue.polycontourOpacity) {
                        layer.setStyle({ opacity: formvalue.polycontourOpacity });             
                        layer.data = {
                            ...layer.data,
                            options: {
                                ...layer.data.options,
                                opacity: formvalue.polycontourOpacity
                            }
                        };
                    }
    
                    // remplissage (fillColor et fillOpacity)
                    if (formvalue.polyColor) {
                        layer.setStyle({ fillColor: formvalue.polyColor });           
                        layer.data = {
                            ...layer.data,
                            options: {
                                ...layer.data.options,
                                fillColor: formvalue.polyColor
                            }
                        };
                    }
                    if (formvalue.polyOpacity) {
                        layer.setStyle({ fillOpacity: formvalue.polyOpacity });          
                        layer.data = {
                            ...layer.data,
                            options: {
                                ...layer.data.options,
                                fillOpacity: formvalue.polyOpacity
                            }
                        };
                    }
                }    
            }      
        });
    },    
    
    AddLayerCollection(layer,data,action){
        return new Promise((resolve) => {
            if (!this.featureGroup) {
                console.error("DrawService : featureGroup non initialisé");
                return;
            }
            if (!this.map) {
                console.error("DrawService : map non initialisée");
                return;
            }

            let alreadyExists = false;
            this.featureGroup.eachLayer((existingLayer) => {
                if (existingLayer.data && existingLayer.data.id === data.id) {
                    alreadyExists = true;
                }
            });

            if (alreadyExists) {
                // Si déjà existante → soit on la met à jour, soit on la remplace
                this.removeLayerCollection(data, 'entity'); // supprime l'ancienne
            }

           
            layer.options = layer.options || {};
            layer.css = layer.css || {};
            layer.sogefi_id = data.id;
            layer.data = data;

            layer._originalStyle = {
                opacity: layer?.options?.opacity ?? 1,
                fillOpacity: layer?.options?.fillOpacity ?? 0.7
            };

            // On ajoute au featureGroup
            this.featureGroup.addLayer(layer);
            
            // Ajout du layer au groupe
            layer.addTo(this.featureGroup);

            // Si featureGroup n’est pas encore sur la carte, l’ajouter
            if (!this.map.hasLayer(this.featureGroup)) {
                this.map.addLayer(this.featureGroup);
            }
            
            if(action == 'zoom'){               
                this.zoomEntites(layer);                
            }

          
        resolve(layer);
        });
    },
  
    zoomEntites(layer){
        let bounds;
        const padding = this.options.zoomPadding || { paddingTopLeft: [800, 0] };
        // Si le zoom actuel est supérieur à 18, on le garde pour éviter de reculer
        const currentZoom = this.map.getZoom();
        const maxZoom = currentZoom > 18 ? currentZoom : 18;
        const options = { ...padding, maxZoom };
        if (typeof layer.getBounds === 'function') {
            bounds = layer.getBounds();
            this.map.fitBounds(bounds, options);
        } else if (typeof layer.getLatLng === 'function') {
            const latlng = layer.getLatLng();
            bounds = L.latLngBounds(latlng, latlng);
            this.map.fitBounds(bounds, options);
        }
    },

    removeLayerCollection(collection,_type){
        let ids = [];
        if (Array.isArray(collection)) {
            // collection peut être : [ {id:1}, {id:2} ] ou [1, 2, 3]
            ids = collection.map(c => {
                if (c === null || c === undefined) return c;
                // Si c est un objet avec id -> renvoyer c.id sinon renvoyer c (id direct)
                return (typeof c === 'object' && c.id !== undefined) ? c.id : c;
            }).filter(id => id !== undefined && id !== null);
        } else if (collection && typeof collection === "object") {
            // collection = { id: X }
            ids = [ collection.id ];
        } else if (collection !== undefined && collection !== null) {
            // collection est un id direct (ex: 123)
            ids = [ collection ];
        } else {
            console.warn("Collection mal formée :", collection);
            return;
        }
        
        this.featureGroup.eachLayer( (layer) => {
            if (ids.includes(layer.data.id)) {
                this.featureGroup.removeLayer(layer);
                this.clearHighlight(layer.data.id);      
            }
        });   
        // Si plus de layers dans le featureGroup, enlève-le de la carte
        if (this.featureGroup.getLayers().length === 0) {
            this.map.removeLayer(this.featureGroup);
        }
    },

    async addOriginLayerFile(layerAdd, iddCollectionSelected, userId) {
        const layersCreated = [];
    
        layerAdd.forEach(objlayer => {
            let layer;
            if (objlayer.geom.type === "Point") {
                layer = this.addPointLayer(objlayer, iddCollectionSelected, userId);
            } else {
                layer = this.addPolygonLayer(objlayer, iddCollectionSelected, userId);
            }
            if (layer) layersCreated.push(layer);
        });
    
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    
        return layersCreated;
    },
    
    
    setZoomEmprise(bounds){
        if (!this.map) {
            console.error("DrawService : map non initialisée");
            return null;
        }
        
        const padding = this.options.zoomPadding || { paddingTopLeft: [800, 0] };
        // Si le zoom actuel est supérieur à 18, on le garde pour éviter de reculer
        const currentZoom = this.map.getZoom();
        const maxZoom = currentZoom > 18 ? currentZoom : 18;
        const options = { ...padding, maxZoom };

        this.map.fitBounds(bounds, options);
    },

    creatDataAnnotation(options,typelay,titre,iddCollectionSelected,userId,observationplus,idlayer){
        const newDataAnnotation = {
            collection_id: iddCollectionSelected,
            css: "null",
            id:idlayer,
            measure: false,
            nb_fichier:0,
            observation: observationplus,
            options: options,
            sogefi_date: new Date().toISOString(),
            sogefi_date_modification: '',
            sogefi_operateur_creation: userId ?? null,
            sogefi_operateur_modification: '',
            tag: false,
            titre: titre,
            type: typelay,
        };
        return newDataAnnotation;
    },

    isValidLatLng(lat, lng) {
        return (
            Number.isFinite(lat) &&
            Number.isFinite(lng) &&
            lat >= -90 && lat <= 90 &&
            lng >= -180 && lng <= 180
        );
    },    

    addPointLayer(objlayer,iddCollectionSelected,userId){
        const lat = parseFloat(objlayer.geom?.coordinates?.[1]);
        const lng = parseFloat(objlayer.geom?.coordinates?.[0]);
        if (!this.isValidLatLng(lat, lng)) {
            return null;
        }
        try{
            const options = {
                icon: L.ExtraMarkers.icon({
                    icon: 'fa-circle',
                    markerColor: '#252525',
                    iconColor: '#FFFFFF',
                    shape: 'circle',
                    prefix: 'fa',
                    svg: true,
                }),
            };
            const layer = L.marker( [parseFloat(objlayer.geom.coordinates[1]), parseFloat(objlayer.geom.coordinates[0])], {
                icon: options.icon
            });
            this.featureGroup.addLayer(layer);
    
            const newDataAnnotation = this.creatDataAnnotation(options,"marker",objlayer.titre,iddCollectionSelected,userId,objlayer.observation,layer._leaflet_id);
    
            const geojson = layer.toGeoJSON();
            layer.data = {
                ...newDataAnnotation,
                id: layer._leaflet_id,
                geom: JSON.stringify(geojson.geometry),
                geojson: {
                    type: geojson.type,
                    geometry: geojson.geometry,
                    properties: { ...newDataAnnotation } // <-- nouvel objet séparé
                }
            };
    
            // Si featureGroup n’est pas encore sur la carte, l’ajouter
            if (!this.map.hasLayer(this.featureGroup)) {
                this.map.addLayer(this.featureGroup);
            }
            return layer;
        }catch (err) {
            return null; 
        }
        
    },

    addPolygonLayer(objlayer,iddCollectionSelected,userId){
        if (!objlayer?.geom?.coordinates?.length) {
            return null;
        }
        try{
            const geojsonFeatures = {
                type: "Feature",
                geometry: objlayer.geom,
                properties: { titre: objlayer.titre }
            };      
            const options = {
                editing: {
                    className: undefined,
                },
                color: "#92bbf4",
            };  
            let geomtype = 'polygon';
            let geomtype2 = 'Polygon';
            if(objlayer.geom.type === 'MultiLineString'){
                geomtype = 'polyline';
                geomtype2 = 'LineString';
            }
    
            const layer = L.geoJSON(geojsonFeatures, {
                style: {
                color: "#92bbf4",
                weight: 2,
                fillOpacity: 0.3
                }
            });
            this.featureGroup.addLayer(layer);
            
            const geojson = layer.toGeoJSON();
            const realIds = Object.keys(layer._layers).map(k => Number(k));
            const newDataAnnotation = this.creatDataAnnotation(options,geomtype,objlayer.titre,iddCollectionSelected,userId,objlayer.observation,realIds[0]);
            let cleanGeometry = null;
    
            if (geojson.features?.length > 0) {
                const g = geojson.features[0].geometry;
        
                cleanGeometry = {
                    type: geomtype2,
                    coordinates: g.coordinates[0] 
                };
            }
        
            layer.data = {
                ...newDataAnnotation,
                id:realIds[0],
                geom: JSON.stringify(cleanGeometry),
                geojson: {
                    type: "Feature",
                    geometry: cleanGeometry,
                    properties: { ...newDataAnnotation } // objet propre
                }
            };
    
            // Si featureGroup n’est pas encore sur la carte, l’ajouter
            if (!this.map.hasLayer(this.featureGroup)) {
                this.map.addLayer(this.featureGroup);
            }
            return layer;
        } catch (err) {
            return null;
        }
        
    },
    
    clearHighlight(id = null) {
        if (!this.highlightLayer) return;
    
        if (id === null) {
            //tout effacer
            this.highlightLayer.clearLayers();
        } else {
            // Supprimer uniquement le layer correspondant à l'id
            const targetId = "highlight_"+id;    
            this.highlightLayer.eachLayer((layer) => {
                if (layer.id === targetId) {
                    this.highlightLayer.removeLayer(layer);
                }
            });
        }
    },

    highlightEntityCollection(entity){
        let alreadyExists = false;
        this.featureGroup.eachLayer((existingLayer) => {
            if (existingLayer.data && existingLayer.data.id === entity.id) {
                alreadyExists = true;
                if(this.highlightLayer){
                    const targetId = "highlight_"+entity.id;    
                    this.highlightLayer.eachLayer((layer) => {
                        if (layer.id === targetId) {
                            this.highlightLayer.removeLayer(layer);
                        }
                    });
                }
            }
        });
        if(alreadyExists){
            this.highlightEntity(entity);
        }

    },

    highlightEntity(entity) {
        if (!this.highlightLayer) {
            this.highlightLayer = L.layerGroup().addTo(this.map);
        }
        const color = 'yellow';
        const geom = entity.geojson.geometry;
        if(geom.type === "Point"){
            if (entity.type === 'marker') {
                // cas point            
                const latlng = [geom.coordinates[1], geom.coordinates[0]]; 
                const width = 40;
                const height = 60;
                const posx = width / 2;
                const posy = height - 12 ;
                 // Création d’un "marker" factice qui sera juste un contour en CSS
                 const textHighlight = L.marker(latlng, {
                    interactive: false,
                    icon: L.divIcon({
                        html: `<div style="
                            width:${width}px;
                            height:${height}px;
                            border: 3px solid ${color};
                            background:rgba(255, 255, 0, 0.3);
                            border-radius: 6px;
                            pointer-events:none;
                        "></div>`,
                        className: "", 
                        iconSize: [width, height],
                        iconAnchor: [posx, posy], 
                    }),
                });
                textHighlight.id = "highlight_"+entity.id;
                this.highlightLayer.addLayer(textHighlight);
            }else if(entity.type === 'circle'){
                const coords = entity.geojson.geometry.coordinates;
                const radius = entity.geojson.properties.options.radius;
                const circleHighlight = L.circle([coords[1], coords[0]], {
                    radius: radius * 1.1,
                    color: color,
                    weight: 4,
                    opacity: 0.8,
                    fillColor: color,
                    fillOpacity: 0.3,
                    interactive: false
                });
            
                circleHighlight.id = "highlight_"+entity.id;
                this.highlightLayer.addLayer(circleHighlight);
            }
        }else{
            // cas polygone / ligne
            const layerhighlight = L.geoJSON(entity.geojson, {
                style: {
                    color:color,
                    weight: 15,
                    opacity: 0.3,
                    fillColor: color,
                    fillOpacity: 0.3
                },
                interactive: false
            });
            
            layerhighlight.id = "highlight_"+entity.id;
            this.highlightLayer.addLayer(layerhighlight);
        }    
    },
    


  };
  
  export default DrawService;
  